import { render, staticRenderFns } from "./ResourceTypeLink.vue?vue&type=template&id=61aca072&"
import script from "./ResourceTypeLink.vue?vue&type=script&lang=js&"
export * from "./ResourceTypeLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports